import React, { useEffect, useState } from 'react';
import AsideLeft from './AppAdminComponents/AsideLeft';
import NavBarNotificationBar from './AppAdminComponents/NavBarNotificationBar';
import { getuser } from '../helpers/user.helper';
import { useNavigate, useParams } from "react-router-dom";
import { GetUser } from '../services/user.service';
import { FullUrlget, put } from '../helpers/api.helper';
import formatString from "format-string-by-pattern";
import { toast } from 'react-toastify';
import Footer from '../components/Footer';

const CpfValidator = require('cpf-cnpj-validator');

export default function UsersDetail(props) {
    let navigate = useNavigate();

    const [nome, setNome] = useState('');
    const [cpf, setcpf] = useState('');
    const [cpfInvalid, setInvalidcpf] = useState(false);
    const [cep, setcep] = useState('');
    const [cepResultSearch, setcepResultSearch] = useState(undefined);
    const [isLoader, setIsloader] = useState(false);
    const [acceptTerms, setacceptTerms] = useState(undefined);

    const [endereco, setendereco] = useState('');
    const [numero, setnumero] = useState('');
    const [bairro, setbairro] = useState('');
    const [cidade, setCidade] = useState('');
    const [estado, setEstado] = useState('');

    const [telFixo, setTelFixo] = useState('');
    const [telCelular, setTelCelular] = useState('');
    const [email, setEmail] = useState('');
    const [codRevendedor, setCodRevendedor] = useState('');
    const [senha, setSenha] = useState('');
    const [confirmSenha, setconfirmSenha] = useState('');
    const [divergentPasswords, setDivergentPasswords] = useState(false);

    let { id } = useParams();

    useEffect(() => {
        let user = getuser();
        //Redireciona caso não esteja logado 
        if (!user) {
            navigate('/login');
        }

        async function fetchData() {
            let userData = await GetUser(id);
            userData = userData.data;
            setNome(userData.nome);
            setcpf(userData.cpf);
            setcep(userData.cep);
            setendereco(userData.endereco);
            setnumero(userData.numero);
            setbairro(userData.bairro);
            setCidade(userData.cidade);
            setEstado(userData.estado);
            setTelFixo(userData.telFixo);
            setTelCelular(userData.telCelular);
            setEmail(userData.email);
            setCodRevendedor(userData?.codRevendedor);
        }

        fetchData();
    }, [])

    const cpfHandleChange = (value) => {
        let isValid = CpfValidator.cpf.isValid(value);
        if (!isValid) setInvalidcpf(true);
        else setInvalidcpf(false);


        let formatCpf = formatString('000.000.000-00', value);
        setcpf(formatCpf);
    }

    const cepHandleChange = async (value) => {
        let formatCep = formatString('00000-000', value);
        if (value.length === 9) {
            let unformatedCep = value.replace('.', '').replace('-', '');


            let resultCpf = await FullUrlget(`http://viacep.com.br/ws/${unformatedCep}/json/`);
            let { data } = resultCpf;
            setcepResultSearch(resultCpf);

            //set all values end with cep search
            setendereco(data.logradouro);
            setbairro(data.bairro);
            setEstado(data.uf);
            setCidade(data.localidade);
        }
        else {
            setcepResultSearch(undefined);
        }

        setcep(formatCep);
    }

    const phoneHandleChange = (value) => {
        let formatPhone = formatString('(00)0000-0000', value);
        setTelFixo(formatPhone)
    }

    const mobilePhoneHandleChange = (value) => {
        let formatMobile = formatString('(00)00000-0000', value);
        setTelCelular(formatMobile);
    }

    const setConfirmHandleChange = (value) => {
        setconfirmSenha(value);
    }

    const confirmSenhaTest = (value) => {
        setconfirmSenha(value);

        if (senha !== confirmSenha) {
            setDivergentPasswords(true);
        }
        else {
            setDivergentPasswords(false);
        }
    }

    const handleCheckedChange = (value)=>{
        setacceptTerms(value.target.checked);
    }

    const handleOnclick = async () => {
        try {
            setIsloader(true);

            let values = {
                nome: nome,
                cpf: cpf,
                cep: cep,
                endereco: endereco,
                numero: numero,
                bairro: bairro,
                cidade: cidade,
                estado: estado,
                telFixo: telFixo,
                telCelular: telCelular,
                email: email,
                senha: senha,
                CodRevendedor: codRevendedor
            }

            
            if(!nome){
                toast.info('Campo nome não pode ser vazio!');
                setIsloader(false);
                return 
            }
            else if(!cpf){
                toast.info('Campo CPF não pode ser vazio!');
                setIsloader(false);
                return 
            }
            else if(!cep){
                toast.info('Campo CEP não pode ser vazio!');
                setIsloader(false);
                return 
            }
            else if(!endereco){
                toast.info('Campo Endereço não pode ser vazio!');
                setIsloader(false);
                return 
            }
            else if(!numero){
                toast.info('Campo Número não pode ser vazio!');
                setIsloader(false);
                return 
            }
            else if(!bairro){
                toast.info('Campo Bairro não pode ser vazio!');
                setIsloader(false);
                return 
            }
            else if(!cidade){
                toast.info('Campo nome não pode ser vazio!');
                setIsloader(false);
                return 
            }
            else if(!estado){
                toast.info('Campo Estado não pode ser vazio!');
                setIsloader(false);
                return 
            }
            else if(!telFixo){
                toast.info('Campo Telefone fixo não pode ser vazio!');
                setIsloader(false);
                return 
            }
            else if(!telCelular){
                toast.info('Campo Telefone celular não pode ser vazio!');
                setIsloader(false);
                return 
            }
            else if(!email){
                toast.info('Campo Email não pode ser vazio!');
                setIsloader(false);
                return 
            }
            else if(!codRevendedor){
                toast.info('Campo Código do revendedor não pode ser vazio!');
                setIsloader(false);
                return 
            }
            
            let result = await put(`usuario/${id}`, values);

            if (result.status === 200) {
                props.navigate("/users");
            }
            else if (result.status === 400) {
                toast.warning('Ocorreu um erro ao enviar suas informações');
            }
            setIsloader(false);
        } catch (error) {
            setIsloader(false);
            toast.warning('Ocorreu um erro ao enviar suas informações');
        }
    }


    return (
        <>
            <div className="wrapper">
                {/* Navbar */}
                <nav className="main-header navbar navbar-expand navbar-white navbar-light">
                    <NavBarNotificationBar />

                </nav>
                <AsideLeft option="users" />
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1 className="m-0 text-dark">Usuários</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                {/* Left col */}
                                <section className="col-lg-12 connectedSortable">
                                    {/* Custom tabs (Charts with tabs)*/}
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="tab-content p-0">                                              
                                                <section className="page-section" id="contact">
                                                    <div className="container">
                                                        <form>
                                                            <div className="row">
                                                                <div className="col-9">
                                                                    <div className="form-group">
                                                                        <label htmlFor="exampleInputEmail1">Nome</label>
                                                                        <input type="text" className="form-control" aria-describedby="nomeHelp" name="nome" value={nome} onChange={(e) => setNome(e.target.value)} />
                                                                        {/* <small id="emailHelp" className="form-text text-muted">Nunca vamos compartilhar seu email, com ninguém.</small> */}
                                                                    </div>
                                                                </div>
                                                                <div className="col-3">
                                                                    <div className="form-group">
                                                                        <label htmlFor="exampleInputEmail1">CPF</label>
                                                                        <input type="text" className="form-control" aria-describedby="emailHelp" value={cpf} onChange={(e) => cpfHandleChange(e.target.value)} />
                                                                        {
                                                                            cpfInvalid &&
                                                                            <small id="emailHelp" className="form-text text-muted "><span className="text-danger">CPF inválido.</span></small>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="row">
                                                                <div className="col-3">
                                                                    <div className="form-group">
                                                                        <label htmlFor="exampleInputEmail1">CEP</label>
                                                                        <input type="text" className="form-control" aria-describedby="emailHelp" value={cep} onChange={(e) => cepHandleChange(e.target.value)} />
                                                                        {/* <small id="emailHelp" className="form-text text-muted">Nunca vamos compartilhar seu email, com ninguém.</small> */}
                                                                    </div>
                                                                </div>
                                                                <div className="col-6">
                                                                    <div className="form-group">
                                                                        <label htmlFor="exampleInputEmail1">Endereço</label>
                                                                        <input type="text" readOnly={cepResultSearch ? true : false} className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" value={endereco} onChange={(e) => setendereco(e.target.value)} />
                                                                        {/* <small id="emailHelp" className="form-text text-muted">Nunca vamos compartilhar seu email, com ninguém.</small> */}
                                                                    </div>
                                                                </div>
                                                                <div className="col-3">
                                                                    <div className="form-group">
                                                                        <label htmlFor="exampleInputEmail1">Número</label>
                                                                        <input type="text" className="form-control" aria-describedby="emailHelp" value={numero} onChange={(e) => setnumero(e.target.value)} />
                                                                        {/* <small id="emailHelp" className="form-text text-muted">Nunca vamos compartilhar seu email, com ninguém.</small> */}
                                                                    </div>
                                                                </div>

                                                            </div>

                                                            <div className="row">
                                                                <div className="col-6">
                                                                    <div className="form-group">
                                                                        <label htmlFor="exampleInputEmail1">Bairro</label>
                                                                        <input type="text" readOnly={cepResultSearch ? true : false} className="form-control" aria-describedby="emailHelp" value={bairro} onChange={(e) => setbairro(e.target.value)} />
                                                                        {/* <small id="emailHelp" className="form-text text-muted">Nunca vamos compartilhar seu email, com ninguém.</small> */}
                                                                    </div>
                                                                </div>
                                                                <div className="col-3">
                                                                    <div className="form-group">
                                                                        <label htmlFor="exampleInputEmail1">Cidade</label>
                                                                        <input type="text" readOnly={cepResultSearch ? true : false} className="form-control" aria-describedby="emailHelp" value={cidade} onChange={(e) => setCidade(e.target.value)} />
                                                                        {/* <small id="emailHelp" className="form-text text-muted">Nunca vamos compartilhar seu email, com ninguém.</small> */}
                                                                    </div>
                                                                </div>
                                                                <div className="col-3">
                                                                    <div className="form-group">
                                                                        <label htmlFor="exampleInputEmail1">Estado</label>
                                                                        <input type="text" readOnly={cepResultSearch ? true : false} className="form-control" aria-describedby="emailHelp" value={estado} onChange={(e) => setEstado(e.target.value)} />
                                                                        {/* <small id="emailHelp" className="form-text text-muted">Nunca vamos compartilhar seu email, com ninguém.</small> */}
                                                                    </div>
                                                                </div>
                                                            </div>


                                                            <div className="row">
                                                                <div className="col-6">
                                                                    <div className="form-group">
                                                                        <label htmlFor="exampleInputEmail1">Telefone Fixo</label>
                                                                        <input type="text" className="form-control" aria-describedby="emailHelp" value={telFixo} onChange={(e) => phoneHandleChange(e.target.value)} />
                                                                        {/* <small id="emailHelp" className="form-text text-muted">Nunca vamos compartilhar seu email, com ninguém.</small> */}
                                                                    </div>
                                                                </div>
                                                                <div className="col-6">
                                                                    <div className="form-group">
                                                                        <label htmlFor="exampleInputEmail1">Telefone Celular</label>
                                                                        <input type="text" className="form-control" aria-describedby="emailHelp" value={telCelular} onChange={(e) => mobilePhoneHandleChange(e.target.value)} />
                                                                        {/* <small id="emailHelp" className="form-text text-muted">Nunca vamos compartilhar seu email, com ninguém.</small> */}
                                                                    </div>
                                                                </div>
                                                            </div>


                                                            <div className="form-group">
                                                                <label htmlFor="exampleInputEmail1">Email</label>
                                                                <input type="email" className="form-control" aria-describedby="emailHelp" value={email} onChange={(e) => setEmail(e.target.value)} />
                                                                {/* <small id="emailHelp" className="form-text text-muted">Nunca vamos compartilhar seu email, com ninguém.</small> */}
                                                            </div>

                                                            <div className="form-group">
                                                                <label htmlFor="exampleInputEmail1">Cod. Revendedor</label>
                                                                <input type="text" className="form-control"  value={codRevendedor} onChange={(e) => setCodRevendedor(e.target.value)} />
                                                                {/* <small id="emailHelp" className="form-text text-muted">Nunca vamos compartilhar seu email, com ninguém.</small> */}
                                                            </div>

                                                           

                                                            
                                                            <button type="button" id="submit-btn" className={`btn btn-primary`} onClick={() => handleOnclick()} ><span className={isLoader ? ' spinner-border spinner-border-sm' : ''}></span> Salvar</button>
                                                        </form>
                                                    </div>
                                                </section>
                                            </div>
                                        </div>
                                    </div>
                                </section>

                            </div>
                        </div>
                    </section>
                </div>

                <Footer />
            </div>
        </>
    )
}
